import { isServer }          from '../../utils';
import { SlotParamsService } from './SlotAppParamsService';

class AARPAnalyticsService {
    constructor() {
        if (isServer) {
            return;
        }

        try {
            (window as any).AARP.MetaInfo.pageData.var1 = 'games';
            (window as any).AARP.MetaInfo.pageData.pagetype = SlotParamsService.params.AARP_ANALYTICS_PAGETYPE;
        } catch (e) {
            console.error('Error occurred while setting analytics data', e);
        }
    }
}

new AARPAnalyticsService();
